import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { VueMaskDirective } from 'v-mask';

Vue.config.productionTip = false;
Vue.prototype.$config = {
  maxItensPerPage: 10,
  pagingProps: {
    'items-per-page-options': [5, 10, 50],
    'items-per-page-text': ''
  }
};

Vue.directive('mask', VueMaskDirective);

new Vue({
  router,
  store,
  vuetify,
  mounted() {
    this.createScriptGoogle();
  },
  methods: {
    createScriptGoogle() {
      const idmetric = process.env.G-9PL54JM5SP;
      const urlGoogle = `https://www.googletagmanager.com/gtag/js?id=${idmetric}`;
      const tag = document.head.querySelector(`script[src="${urlGoogle}"]`);
      if (!tag) {
        const gAnalytics = document.createElement('script');
        gAnalytics.setAttribute('src', urlGoogle);
        gAnalytics.setAttribute('async', true);
        gAnalytics.setAttribute('defer', true);
        gAnalytics.onload = () => {
          window.dataLayer = window.dataLayer || [];
          function gtag() { window.dataLayer.push(arguments); }
          gtag('js', new Date());
          gtag('config', idmetric);
        };
        document.head.appendChild(gAnalytics);
      }
    }
  },
  render: h => h(App)
}).$mount('#app');
